const SET_EPISODES_BY_ID = '_podcast/SET_EPISODES_BY_ID';

export default {
  SET_EPISODES_BY_ID,
};
